export default function Unauthorized() {
  return <h2 style={{ color: 'red' }}>⛔ Accès refusé - Administrateurs uniquement</h2>;
}
